import { lazy } from 'react';

const ClientsPage = lazy(() => import('../pages/Clients.page'));

const ClientsRoutes = [
    {
        path: '/clients',
        element: <ClientsPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ClientsRoutes };
